import styled from 'styled-components'

export const Container = styled.ul`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    text-align: center;
`

